var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHistoryColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "history"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.47039 17.2225C5.22885 20.0884 8.39118 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C8.72855 2 5.82401 3.57093 3.99958 5.99958L2.85355 4.85355C2.53857 4.53857 2 4.76166 2 5.20711V9.5C2 9.77614 2.22386 10 2.5 10H6.79289C7.23835 10 7.46143 9.46143 7.14645 9.14645L5.43173 7.43173C6.87714 5.3574 9.28005 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C9.14844 20 6.64534 18.5081 5.2287 16.2622C5.08147 16.0288 4.77925 15.9386 4.53698 16.0708L3.65875 16.5498C3.41617 16.6821 3.32588 16.987 3.47039 17.2225Z",
  fill: "#464A51"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.513 6.99933H12.513C12.7891 6.99933 13.013 7.22319 13.013 7.49933V11.5777L15.9126 14.4773C16.1079 14.6726 16.1079 14.9892 15.9126 15.1845L15.2055 15.8916C15.0102 16.0868 14.6937 16.0868 14.4984 15.8916L11.013 12.4062V7.49933C11.013 7.22319 11.2369 6.99933 11.513 6.99933Z",
  fill: "#464A51"
})))));
export default SvgIconHistoryColor;